export const changeBody = {
    methods: {
        changeBody(objParameters) {
            if (typeof objParameters !== 'object') {
                return;
            }
            if (objParameters.hasOwnProperty('class')) {
                document.body.className = objParameters.class;
            }
            if (objParameters.hasOwnProperty('style')) {
                if (Object.keys(objParameters.style).length !== 0) {
                    Object.entries(objParameters.style).forEach(([key, value]) => {
                        document.body.style[key] = value;
                    })
                }
            }
        },
    }
}
